export default __webpack_public_path__ + "static/media/loading.167184d6.gif";